

import JobStreetView from "../../offers/status/jobStreetView";
import Send from '../../../../../_asset/img/send-2.svg';
import { useState } from "react";
import { useEffect } from "react";
// import SideDrawer from "./sideDrawer";
import ProgressCircle from '../utils/ProgressCircle';

const UnassignedGridView = ({data}) => {
    const [open, setOpen] = useState(false);
    const [getByItem, setGetByItem] = useState(null);

    useEffect(() => {
        if(!open){
            setGetByItem(null);
        }
    }, [open]);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4">
            {
                data.length > 0 && data.map((job, index) => {
                  const jobDescription = `n/a`;
                  const percent = job?.statistics?.overallCoverage || 0;
                  const color = percent === 100 ? '#52c41a' : '#3385ff';

                  return (
                    <div key={job._id} className="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-200">
                      <div className="relative h-54">
                      <JobStreetView job={job} />
                      <span className="w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center cursor-pointer absolute bottom-4 right-4 z-10" onClick={() => {setOpen(true); setGetByItem(job)}}>
                          <img src={Send} alt="" />
                      </span>
                      </div>
                      <div className="p-4">
                      <div className="mb-4">
                        <div className="font-semibold text-lg text-gray-900 mb-1">

                          {/* will be link to customer page  */}
                          {job.customer_company_id.companyFriendlyName}
                        </div>
                      <div className="text-sm text-gray-600">{job.formattedAddress}</div>
                      </div>
                      <hr className="my-4 border-gray-200" />
                      <div className="space-y-3">
                        <div className="flex justify-between items-center">
                            <p className="text-xs text-gray-500 uppercase tracking-wide">Disputed Offers</p>
                            <p className="text-sm font-medium text-gray-900">{job.statistics?.offerCounts?.disputed || 0}</p>
                        </div>
                        <div className="flex justify-between items-center">
                            <p className="text-xs text-gray-500 uppercase tracking-wide">Total Offers</p>
                            <p className="text-sm font-medium text-gray-900">{job.statistics?.validOffersCount || 0}</p>
                        </div>
                        <div className="flex justify-between items-center">
                            <p className="text-xs text-gray-500 uppercase tracking-wide">Shift Coverage</p>
                            <ProgressCircle
                                percent={parseInt(percent.toFixed(0))}
                                strokeColor={color}
                                size={40}
                            />
                        </div>
                      </div>
                      <div className="mt-4">
                            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                                #{job.service.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </span>
                        </div>
                      {/* <hr /> */}
                      </div>
                    </div>
                  );
                })
              }

            {/* <SideDrawer isOpen={open} setIsOpen={setOpen} getByItem={getByItem} /> */}
        </div>
    )
};

export default UnassignedGridView;